import React from 'react';
import StereoWhatsAppFloatButton from '@magalu/stereo-ui/molecules/WhatsAppFloatButton';
import { cookiesConstants, getCookie } from '@magalu/mixer-utils';
import { DEFAULT_TEXT, LU_WHATSAPP_NUMBER } from './constants';
var WhatsAppFloatButton = function WhatsAppFloatButton() {
  var WHATSAPP_TEXT = cookiesConstants.WHATSAPP_TEXT;
  var text = getCookie(WHATSAPP_TEXT) || DEFAULT_TEXT;
  var url = new URL("https://wa.me/".concat(LU_WHATSAPP_NUMBER));
  url.searchParams.set('text', text);
  return React.createElement(StereoWhatsAppFloatButton, {
    href: url.href
  });
};
WhatsAppFloatButton.ssr = false;
export default WhatsAppFloatButton;